var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-menu",class:_vm.checkRoute()},_vm._l((_vm.sections),function(section){return _c('RouterLink',{key:`menu__navbar__${section.key}`,staticClass:"navbar-menu__item",class:_vm.$route.path === section.key ? 'navbar-menu__item--active' : '',attrs:{"to":section.key}},[_vm._v(_vm._s(section.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }